<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="document-content">
    <h3 class="section-title">Information</h3>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label for="name">Name</mat-label>
      <input matInput id="name" formControlName="name" placeholder="e.g., HR Onboarding Workflow" />

      @if (formControls.name.errors?.['required'] && formControls.name.touched) {
        <mat-error> Name is required. </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label for="description">Description</mat-label>
      <textarea
        matInput
        id="description"
        formControlName="description"
        placeholder="e.g., Updated basic template for project workspaces."
        rows="5"
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="8"></textarea>
      @if (formControls.description.errors?.['required'] && formControls.description.touched) {
        <mat-error> Description is required. </mat-error>
      }
    </mat-form-field>

    <h3 class="section-title">File Attachment</h3>

    <div class="file-upload-container">
      <app-file-selector
        [allowedExtensions]="supportedFileExtensions"
        [multiple]="false"
        (filesChanged)="onFilesChanged($event)">
      </app-file-selector>
      <mat-hint>Can be provided later</mat-hint>
    </div>

    <h3 class="section-title">Default Personas</h3>
    <app-persona-selector
      [initialSelectedPersonaIds]="formControls.default_personas.value"
      (selectionChange)="onPersonasChanged($event)">
    </app-persona-selector>

    <div class="button-holder">
      <app-loader-button [loading]="loading" type="submit" [disabled]="loading" mat-flat-button color="primary">
        {{ submitButtonText }}
      </app-loader-button>
    </div>
  </div>
</form>
